import withModules from 'cccisd-laravel-assignment/dist/components/navigations/withModules';
import courseWrapper from 'cccisd-laravel-assignment/dist/components/navigations/courseWrapper';
import MKMWithModules from '../../components/withModules';

const navigations = [withModules, courseWrapper, MKMWithModules];

export default navigations;
